import {BrowserModule} from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';

import {DipRegistrationComponent} from './dip-registration.component';
import {DipRegistrationCoreModule} from './core/dip-registration-core.module';
import {DipRegistrationOverviewComponent} from './dip-registration-overview/dip-registration-overview.component';
import {DipRegistrationRoutingModule} from './dip-registration-routing.module';
import {DipRegistrationCustomerIdentificationComponent} from './dip-registration-customer-identification/dip-registration-customer-identification.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {DipRegistrationHeaderComponent} from './dip-registration-header/dip-registration-header.component';
import {DipRegistrationFooterComponent} from './dip-registration-footer/dip-registration-footer.component';
import {DipRegistrationInitializerService} from './core/services/dip-registration-initializer.service';
import {DipRegistrationPrimaryAccountModalComponent} from './modals/dip-registration-primary-account-modal/dip-registration-primary-account-modal.component';
import {DipRegistrationPhoneNumberModalComponent} from './modals/dip-registration-phone-number-modal/dip-registration-phone-number-modal.component';
import {DipRegistrationExistingAccountComponent} from './dip-registration-existing-account/dip-registration-existing-account.component';
import {DipRegistrationSessionExpiredComponent} from './dip-registration-session-expired/dip-registration-session-expired.component';
import {DipRegistrationConfirmationModalComponent} from './modals/dip-registration-confirmation-modal/dip-registration-confirmation-modal.component';
import {DipRegistrationPhoneNumberListComponent} from './dip-registration-phone-number-list/dip-registration-phone-number-list.component';
import {DipRegistrationExpirationModalComponent} from './modals/dip-registration-expiration-modal/dip-registration-expiration-modal.component';
import {DipRegistrationApplicationErrorComponent} from './dip-registration-error/dip-registration-application-error/dip-registration-application-error.component';
import {DipRegistrationOverviewResolver} from './dip-registration-overview/dip-registration-overview-resolver.service';
import {DipRegistrationPageNotFoundErrorComponent} from './dip-registration-error/dip-registration-page-not-found-error/dip-registration-page-not-found-error.component';
import {IMaskModule} from 'angular-imask';
import { ModalModule } from './shared/components/modal/modal.module';
import { LoaderModule } from './shared/components/loader/loader.module';
import { PhoneNumberModule } from './shared/components/phone-number/phone-number.module';
import { WebMetricsModule } from './shared/components/web-metrics/web-metrics.module';
import { PatternFilterModule } from './shared/directives/pattern-filter/pattern-filter.module';
import { IdleService } from './shared/services/idle.service';

export function dipRegistrationInitializerFactory(dipRegistrationInitializerService: DipRegistrationInitializerService) {
  // init app config
  return (): Promise<any> => dipRegistrationInitializerService.init();
}

@NgModule({
    declarations: [
        DipRegistrationComponent,
        DipRegistrationOverviewComponent,
        DipRegistrationCustomerIdentificationComponent,
        DipRegistrationHeaderComponent,
        DipRegistrationFooterComponent,
        DipRegistrationPrimaryAccountModalComponent,
        DipRegistrationPhoneNumberModalComponent,
        DipRegistrationExistingAccountComponent,
        DipRegistrationSessionExpiredComponent,
        DipRegistrationConfirmationModalComponent,
        DipRegistrationPhoneNumberListComponent,
        DipRegistrationExpirationModalComponent,
        DipRegistrationApplicationErrorComponent,
        DipRegistrationPageNotFoundErrorComponent
    ],
    imports: [
        BrowserModule,
        DipRegistrationCoreModule,
        DipRegistrationRoutingModule,
        BrowserAnimationsModule,
        ModalModule,
        LoaderModule,
        PhoneNumberModule,
        WebMetricsModule,
        PatternFilterModule,
        IMaskModule
    ],
    providers: [
        provideAppInitializer(() => {
        const initializerFn = (dipRegistrationInitializerFactory)(inject(DipRegistrationInitializerService));
        return initializerFn();
      }),
        DipRegistrationOverviewResolver,
        IdleService
    ],
    bootstrap: [DipRegistrationComponent]
})
export class DipRegistrationModule {
}
